<!-- 开药申请 -->
<template>
<div>
  <el-dialog
        title="移动开药"
        :visible.sync="billVisible"
        width="90%"
        class="patRecord-dialog"
        @close="handleClose"
    >
    <strong>请选择收货地址</strong>
    <div class="address-list">
        <el-radio-group v-if="addressList && addressList.length > 0" v-model="addressId">
            <el-radio v-for="(item,index) in addressList" :key="index" :label="item.addressId">
                <strong>{{item.recipient}}</strong>
                <span>{{item.telephone}}</span>
                <div>{{item.provinceCity}} {{item.address}}</div>
            </el-radio>
        </el-radio-group>
        <div v-else>
            暂无收货地址~
        </div>
    </div>
    <div class="add-button" @click="addAddress"><i class="el-icon-plus"></i>新增收货地址</div>
    <span slot="footer" class="dialog-footer">
        <el-button type="success" size="medium" @click="save">提 交</el-button>
        <el-button type="danger" size="medium" @click="handleClose">关 闭</el-button>
    </span>
    </el-dialog>
    <editAddressDialog :visible.sync="addVisible" :patInfo="patInfo" @refresh="getAddressList"></editAddressDialog>
</div>
</template>

<script>
import { apply2YunInHospital, getAddressListApi } from '../../api/appletApi.js'
import editAddressDialog from './editAddressDialog.vue'
export default {
  name: '',
  mixins: [],
  components: {editAddressDialog},
  props: {
    visible: {
      Boolean,
      default: false
    },
    myUserId: {
      String,
      default: ''
    },
    patInfo: {
      Object,
      default: () => {}
    }
  },
  data () {
    return {
      billVisible: false,
      addressId: '',
      radio: '',
      addVisible: false,
      addressList: []
    }
  },
  watch: {
    visible (val) {
      this.billVisible = val
      if (val) {
        this.getAddressList()
      }
    }
  },
  computed: {},
  created () {},
  mounted () {},
  methods: {
    getAddressList () {
      let params = {
        patId: this.patInfo.patId
      }
      this.addressList = []
      getAddressListApi(params).then(data => {
        this.addressList = data
      })
    },
    handleClose () {
      this.addressId = ''
      this.$emit('update:visible', false)
    },
    save () { // 提交申请
      if (!this.addressId) {
        this.$message.error('请选择一个收货地址')
        return
      }
      let params = {
        userId: this.myUserId,
        patId: this.patInfo.patId,
        addressId: this.addressId
      }
      apply2YunInHospital(params).then(data => {
        if (data) {
          this.$message.success('已向院内提交申请，请到院内PC端操作')
          this.handleClose()
        }
      })
    },
    addAddress () { // 新增收货地址
      this.addVisible = true
    }
  }
}
</script>
<style lang='scss' scoped>
.patRecord-dialog{
    /deep/ .el-dialog{
        border-radius: 8px;
        .el-dialog__body{
            padding: 0 15px 15px 15px;
        }
    }
}
.address-list{
    width: 100%;
    max-height: 300px;
    padding: 5px;
    overflow-y: auto;
    margin-bottom: 15px;
    .one-address{
        padding: 10px 0;
    }
    .el-radio-group{
        .el-radio{
            margin-right: 30px;
        /deep/ .el-radio__input{
                margin-top: -40px;
            }
        /deep/ .el-radio__label{
                display: inline-block;
                div{
                    margin: 10px 0;
                    white-space: pre-wrap;
                }
            }
        }
    }
}
.add-button{
    padding: 10px;
    cursor: pointer;
    border: 2px solid orange;
    border-radius: 25px;
    background: #ff8d00;
    text-align: center;
    color: #fff;
    margin:0 25px;
    width:calc(100% - 70px);
    i{
        margin-right: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// packages/chat/src/presribeDialog.vue